import { useEffect, useState, useRef } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FaPaintBrush, FaLaptopCode } from "react-icons/fa";

import "../styles/Header.css";

const navItems = [
  {
    to: "/art",
    label: "Mỹ Thuật",
    icon: <FaPaintBrush className="header__icon" />,
    match: (path) =>
      path === "/art" || path.startsWith("/art/") || path === "/",
  },
  {
    to: "/code",
    label: "Lập Trình",
    icon: <FaLaptopCode className="header__icon" />,
    match: (path) => path === "/code" || path.startsWith("/code/"),
  },
];

function Header() {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    document.title = "Kids Learn - Khóa học Lập trình cho thiếu nhi";
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;

      setIsScrolled(currentY > 10);
      setIsVisible(currentY < 10 || currentY < lastScrollY.current);
      lastScrollY.current = currentY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const renderNavItem = ({ to, label, icon, match }) => {
    const isActive = match(location.pathname);
    return (
      <Nav.Link
        key={to}
        as={Link}
        to={to}
        className={`header__link ${isActive ? "active" : ""}`}
        aria-current={isActive ? "page" : undefined}
      >
        {icon}
        {label}
      </Nav.Link>
    );
  };

  return (
    <header
      className={`header 
        ${isScrolled ? "header--scrolled" : ""}
        ${isVisible ? "header--visible" : "header--hidden"}`}
    >
      <Navbar
        bg="light"
        expand="md"
        className="header__navbar py-3"
      >
        <Container>
          <Navbar.Brand
            as={Link}
            to="/art"
            className="header__brand"
          >
            <img
              src="/logo.webp"
              alt="Kids Learn Logo"
              className="header__logo"
            />
            <div className="header__brand-text">
              <span className="header__brand-name">Kids Learn</span>
              <span className="header__brand-sub">
                Mỹ thuật & Lập trình cho trẻ
              </span>
            </div>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="ms-auto header__nav gap-2">
              {navItems.map(renderNavItem)}
            </Nav>
            <Link
              to="/register"
              className="header__register-btn"
            >
              Đăng ký
            </Link>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}

export default Header;
